import React from 'react';
import { ModalHeader } from 'reactstrap';
import {Button,Dialog, ListItemText, ListItem, List, makeStyles, IconButton, Toolbar, Typography, Slide, Divider, DialogActions, DialogContent,Paper, Grid} from '@material-ui/core';
import IntlMessages from 'util/IntlMessages';
import { Close} from '@material-ui/icons'
import data from '../../Widgets/data'
import WidgetItem from './widgetItem'
//import Image from '../../../Images/notyfile_dashboard_bg.png'
import { useSelector } from 'react-redux';
import {isUndefined} from 'lodash'

const useStyles = makeStyles((theme) => ({
  bg: {
  //  backgroundImage: `url(${Image})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  catTitle: {
    color: 'rgb(12, 150, 156)',
    fontWeight: 500,
    fontSize: 35,
    marginBottom: 0,
    marginTop: 25,
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog(props) {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false);
  const [blocks, setBlocks] = React.useState([])
  const Flags = useSelector(state => state.accountsData.Flags)
  const authUser = useSelector(state => state.auth.authUser)

  const handleClickOpen = () => {
    setOpen(true);
    setBlocks([])
  };

  const handleClose = () => {
    setOpen(false);
    setBlocks([])
  };
  const handleComplete = () => {
    props.addBlocks(blocks)
    handleClose()
  }
  const handleRemoveBlock = (block) => {
    setBlocks(state => state.filter(s => s.type !== block.type))
  }
  const handleAddBlock = (block) => {
    setBlocks(state => [...state, block])
  } 

  return (
    <>
      <Button
        className="mr-2"
        variant="outlined"
        color="primary"
        size="small"
        onClick={handleClickOpen}
      >
        <IntlMessages id="Add"/>
      </Button>
      {
        open?
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition} classes={{paper: classes.bg}}>
        <ModalHeader className="modal-box-header bg-primary text-white" style={{borderBottom: '1px solid #0c969c'}}>
        <IntlMessages id="DashBoard.Add.Widget"/>
            <IconButton className="text-white"
                onClick={handleClose}>
                <Close />
            </IconButton>
        </ModalHeader>
        <DialogContent dividers >
          <Typography component="h1" className={classes.catTitle}><IntlMessages id="Other"/></Typography>
          <Grid container spacing={3} className="w-100 m-0">
            {
              data.filter(d => d.category === 1 && !d.hidden).map((d, i) => {
                return (
                  <Grid item xs="12" md="4" lg="3" xl="2" >
                    <WidgetItem _item={d} isFrom={1} handleAddBlock={handleAddBlock} handleRemoveBlock={handleRemoveBlock}/>
                  </Grid>
                )
              })
            }
          </Grid>
         <Typography component="h1" className={classes.catTitle}><IntlMessages id="DashBoard.Individual"/></Typography>
          <Grid container spacing={3} className="w-100 m-0">
            {
              data.filter(d => d.category === 2 && !d.hidden).map((d, i) => {
                if(authUser.user_role === 1){
                  return (
                    <Grid item  xs="12" md="4" lg="3" xl="2">
                      <WidgetItem  _item={d} handleAddBlock={handleAddBlock} handleRemoveBlock={handleRemoveBlock}/>
                    </Grid>
                  )
                }else{
                  if(isUndefined(d.Admin)){
                    return (
                      <Grid item  xs="12" md="4" lg="3" xl="2">
                        <WidgetItem  _item={d} handleAddBlock={handleAddBlock} handleRemoveBlock={handleRemoveBlock}/>
                      </Grid>
                    )
                  }
                }
                
              })
            }
          </Grid>
         
          <Typography component="h1" className={classes.catTitle}><IntlMessages id="Order"/></Typography>
          <Grid container spacing={3} className="w-100 m-0">
            {
              data.filter(d => d.category === 11 && !d.hidden).map((d, i) => {
                if(authUser.user_role === 1){
                  return (
                    <Grid item xs="2">
                      <WidgetItem  _item={d} handleAddBlock={handleAddBlock} handleRemoveBlock={handleRemoveBlock}/>
                    </Grid>
                  )
                }else{
                  if(isUndefined(d.Admin)){
                    return (
                      <Grid item xs="2">
                        <WidgetItem  _item={d} handleAddBlock={handleAddBlock} handleRemoveBlock={handleRemoveBlock}/>
                      </Grid>
                    )
                  }
                }
                
              })
            }
          </Grid>
          {
            parseInt(Flags.Projekt) === 1 && parseInt(authUser.user_SeeProjects) === 1 &&
            <>
             <Typography component="h1" className={classes.catTitle}><IntlMessages id="Project"/></Typography>
          <Grid container spacing={3} className="w-100 m-0">
            {
              data.filter(d => d.category === 10 && !d.hidden).map((d, i) => {
                return (
                  <Grid item xs="2">
                    <WidgetItem  _item={d} handleAddBlock={handleAddBlock} handleRemoveBlock={handleRemoveBlock}/>
                  </Grid>
                )
              })
            }
          </Grid>
            </>
          }
         {
          parseInt(Flags.Arende) === 1 && parseInt(authUser.user_SeeCasesList) === 1 &&
          <>
          <Typography component="h1" className={classes.catTitle}><IntlMessages id="Errand"/></Typography>
          <Grid container spacing={3} className="w-100 m-0">
            {
              data.filter(d => d.category === 7 && !d.hidden).map((d, i) => {
                return (
                  <Grid item xs="2">
                    <WidgetItem  _item={d} handleAddBlock={handleAddBlock} handleRemoveBlock={handleRemoveBlock}/>
                  </Grid>
                )
              })
            }
          </Grid>
          </>
         }
          
          <Typography component="h1" className={classes.catTitle}><IntlMessages id="Agreement"/></Typography>
          <Grid container spacing={3} className="w-100 m-0">
            {
              data.filter(d => d.category === 8 && !d.hidden).filter(d=>d.type !== 64).filter(d=>d.type !== 65).map((d, i) => {
                return (
                  <Grid item xs="2">
                    <WidgetItem  _item={d} handleAddBlock={handleAddBlock} handleRemoveBlock={handleRemoveBlock}/>
                  </Grid>
                )
              })
            }
          </Grid> 
        {/*  <Typography component="h1" className={classes.catTitle}><IntlMessages id="DashBoard.Customized.sale"/></Typography>
          <Grid container spacing={3} className="w-100 m-0">
            {
              data.filter(d => d.category === 4).map((d, i) => {
                return (
                  <Grid item xs="2">
                    <WidgetItem  _item={d} handleAddBlock={handleAddBlock} handleRemoveBlock={handleRemoveBlock}/>
                  </Grid>
                )
              })
            }
          </Grid>
          <Typography component="h1" className={classes.catTitle}><IntlMessages id="DashBoard.Customized.Booking"/></Typography>
          <Grid container spacing={3} className="w-100 m-0">
            {
              data.filter(d => d.category === 5).map((d, i) => {
                return (
                  <Grid item xs="2">
                    <WidgetItem  _item={d} handleAddBlock={handleAddBlock} handleRemoveBlock={handleRemoveBlock}/>
                  </Grid>
                )
              })
            }
          </Grid>
          <Typography component="h1" className={classes.catTitle}><IntlMessages id="Errand"/></Typography>
          <Grid container spacing={3} className="w-100 m-0">
            {
              data.filter(d => d.category === 7).map((d, i) => {
                return (
                  <Grid item xs="2">
                    <WidgetItem  _item={d} handleAddBlock={handleAddBlock} handleRemoveBlock={handleRemoveBlock}/>
                  </Grid>
                )
              })
            }
          </Grid>
          <Typography component="h1" className={classes.catTitle}><IntlMessages id="Agreement"/></Typography>
          <Grid container spacing={3} className="w-100 m-0">
            {
              data.filter(d => d.category === 8).map((d, i) => {
                return (
                  <Grid item xs="2">
                    <WidgetItem  _item={d} handleAddBlock={handleAddBlock} handleRemoveBlock={handleRemoveBlock}/>
                  </Grid>
                )
              })
            }
          </Grid>
          {
            parseInt(Flags.Lynes) === 1 &&
            <>
              <Typography component="h1" className={classes.catTitle}><IntlMessages id="DashBoard.Customized.TeleCall"/></Typography>
              <Grid container spacing={3} className="w-100 m-0">
                {
                  data.filter(d => d.category === 6).map((d, i) => {
                    return (
                      <Grid item xs="2">
                        <WidgetItem  _item={d} handleAddBlock={handleAddBlock} handleRemoveBlock={handleRemoveBlock}/>
                      </Grid>
                    )
                  })
                }
              </Grid>
            </>
          }
          */}
        </DialogContent>
        <DialogActions>
            <div className="col-6">
                <div className="form-group mb-0">
                  <Button
                    variant="outlined"
                    color="secondary"
                    size="small"
                    onClick={handleClose}
                  >
                    <IntlMessages id="Cancel"/>
                  </Button>
                </div>
            </div>
            <div className="col-6 d-flex justify-content-end">
                <div className="form-group mb-0">
                  <Button
                    variant='contained'
                    color="primary"
                    size="small"
                    onClick={handleComplete}
                  >
                    <IntlMessages id="Add"/>
                  </Button>
                </div>
            </div>
        </DialogActions>
      </Dialog>
      :""
    }
    </>
  );
}